// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._zulpu2gc{gap:var(--ds-space-100,8px)}._1e0c1txw{display:flex}\n._1tke1ylp{min-height:40px}\n._4cvr1h6o{align-items:center}", ""]);
// Exports
module.exports = exports;
